import Marquee from 'react-fast-marquee';

const WORDS = ['INDIE-ROCK', 'INDIE-POP', 'BRITPOP', 'ALTERNATIVE', 'INDIE-DANCE', 'POST-PUNK'];

export const MarqueeStrip = ({ reverse = false }) => (
  <div data-testid="marquee-strip" className="border-y border-white/10 bg-ink py-4 sm:py-6 overflow-hidden">
    <Marquee direction={reverse ? 'right' : 'left'} speed={45} gradient={false}>
      {WORDS.concat(WORDS).map((w, i) => (
        <span
          key={`${w}-${i}`}
          className="font-heading uppercase text-4xl sm:text-6xl mx-6 text-stroke"
        >
          {w} <span className="text-acid not-italic"> • </span>
        </span>
      ))}
    </Marquee>
  </div>
);
